import qc from 'qc'
import qcGame from '@ps/bridge/qc/qc-game'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { EditorDataScript } from '@ps/bridge/qc/scripts/editor'
import { getExt } from '@ps/utils/game'
import { removeFileExtension } from '@com/utils/file'
import { ElUploadInternalFileDetail } from 'element-ui/types/upload'
import { resetNodeDefaultLayout } from '@ps/bridge/qc/node/utils'
import i18n from '@ps/lang'
import { isEraseNodeChild } from '@ps/bridge/qc/base'
import { scripts } from '@ps/bridge/qc/scripts'

export const initState = {
  data: [],
  defActionName: '',
  playTime: -1, // 播放次数，当传 -1 代表无限循环，默认循环
  autoDestory: false,
  interval: 100,
  pingpong: false,
  defPlay: true,
}

export function addSequenceFrameNode({
  scene,
  pathPrefix,
  fileList,
  actionName,
}: {
  scene: qc.Node
  pathPrefix: string
  fileList: ElUploadInternalFileDetail[]
  actionName: string
}): {
  node: qc.Node
  moveClipScript: any
  binList: string[]
} {
  const node = qcGame.add.image(scene)
  resetNodeDefaultLayout(node)
  node.name = i18n.t(
    'workbench.resourceManagers.categoryList.effect.xlzTxt',
  ) as string

  const ped = editorScript.getScript(node) as EditorDataScript
  ped.sequenceFrameType = getExt(fileList[0].name)
  // 基础包中的ps.MovieClip脚本可能会回存在不兼容的情况
  const mv = node.addScript('ps.MovieClip')
  const binList = fileList.map((item) => {
    return `${pathPrefix}/${removeFileExtension(item.name)}.bin`
  })
  // 新增序列帧的时候传出默认 state, 避免使用当前的 state ，不然会被当前编辑参数影响
  const defaultState = initState
  // 赋值当前的 MovieClip 属性
  mv.data = {
    [actionName]: binList.join(','),
    allFramePlaySmart: binList.join(','),
  }
  mv.defActionName = actionName
  mv.playTime = defaultState.playTime
  mv.interval = defaultState.interval
  mv.autoDestory = defaultState.autoDestory
  mv.pingpong = defaultState.pingpong
  mv.defPlay = defaultState.defPlay
  mv.initData()

  // 擦除组件节点需要添加擦除图层脚本
  if (isEraseNodeChild(node)) {
    node.addScript(scripts.eraseLayer.name)
  }

  return {
    node,
    moveClipScript: mv,
    binList,
  }
}

export function getXlzDirectory(node: qc.Node): string | void {
  const data = node.getScript('ps.MovieClip').data || {}
  if (data.allFramePlaySmart) {
    const arr = data.allFramePlaySmart.split(',')[0].split('/')
    arr.pop()
    return arr.join('/')
  }
}
